import React from 'react';
import PropTypes from 'prop-types';
import { UnmountClosed } from 'react-collapse';
import { presets } from 'react-motion';
import styled from 'styled-components';

import Button from '@style-guide/components/Button';
import Input from '@style-guide/components/Input';

import Arrow from './shared/Arrow';
import Body from './shared/Body';
import Header from './shared/Header';
import Title from './shared/Title';
import Wrapper from './shared/Wrapper';

const FullWidthInput = styled.div`
  width: 100%;

  > div {
    width: 100%;
  }
`;

FullWidthInput.displayName = 'FullWidthInput';

class NameFilter extends React.Component {
  constructor() {
    super();

    this.state = {
      isOpened: true,
      criteria: {
        firstName: '',
        lastName: '',
      },
      prevCriteria: {
        firstName: '',
        lastName: '',
      },
    };

    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTextInputChange = this.handleTextInputChange.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    const nextFilterValue = {
      firstName: props.filterValueFirstName,
      lastName: props.filterValueLastName,
    };

    if (state.prevCriteria.firstName !== nextFilterValue.firstName ||
      state.prevCriteria.lastName !== nextFilterValue.lastName) {
      return {
        /*
          we have to make new object references for each state field,
          otherwise, when you update one state field, the other will also update
        */
        criteria: Object.assign({}, nextFilterValue),
        prevCriteria: Object.assign({}, nextFilterValue),
      };
    }

    return {
      ...state,
    };
  }

  handleKeyPress(e) {
    const { filterUpdate } = this.props;
    const {
      firstName,
      lastName,
    } = this.state.criteria;

    if (e.charCode === 13) {
      this.setState({
        ...this.state,
        prevCriteria: {
          firstName,
          lastName,
        },
      });

      filterUpdate('firstName', firstName);
      filterUpdate('lastName', lastName);
    }

    return undefined;
  }

  handleSubmit() {
    const { filterUpdate } = this.props;
    const {
      firstName,
      lastName,
    } = this.state.criteria;

    this.setState({
      ...this.state,
      prevCriteria: {
        firstName,
        lastName,
      },
    });

    filterUpdate('firstName', firstName);
    filterUpdate('lastName', lastName);
  }

  handleTextInputChange(field, value) {
    this.setState((prevState) => {
      const newState = Object.assign({}, prevState);

      newState.criteria[field] = value;

      return {
        ...newState,
      };
    });
  }

  toggleCollapse() {
    this.setState(prevState => ({
      isOpened: !prevState.isOpened,
    }));
  }

  render() {
    const {
      isOpened,
      criteria: {
        firstName,
        lastName,
      },
    } = this.state;

    return (
      <Wrapper>
        <Header
          id="filterNameCollapseToggle"
          $isOpened={isOpened}
          onClick={this.toggleCollapse}
        >
          <Title>Name</Title>
          <Arrow
            isOpened={isOpened}
          />
        </Header>
        <UnmountClosed
          isOpened={isOpened}
          presets={presets.gentle}
        >
          <Body
            id="filterNameWrapper"
          >
            <FullWidthInput>
              <Input
                id="filterFirstNameInput"
                onChange={e => this.handleTextInputChange('firstName', e.target.value)}
                onKeyPress={this.handleKeyPress}
                placeholder="First Name"
                style={{
                  marginBottom: '15px',
                }}
                type="text"
                value={firstName}
              />
            </FullWidthInput>
            <FullWidthInput>
              <Input
                id="filterLastNameInput"
                onChange={e => this.handleTextInputChange('lastName', e.target.value)}
                onKeyPress={this.handleKeyPress}
                placeholder="Last Name"
                style={{
                  marginBottom: '15px',
                }}
                type="text"
                value={lastName}
              />
            </FullWidthInput>
            <Button
              onClick={this.handleSubmit}
            >
              Search
            </Button>
          </Body>
        </UnmountClosed>
      </Wrapper>
    );
  }
}

// we are using the props, just in the static method (deriveStateFromProps)
NameFilter.propTypes = {
  filterUpdate: PropTypes.func.isRequired,
  /* eslint-disable react/no-unused-prop-types */
  filterValueFirstName: PropTypes.string,
  filterValueLastName: PropTypes.string,
  /* eslint-enable react/no-unused-prop-types */
};

NameFilter.defaultProps = {
  filterValueFirstName: '',
  filterValueLastName: '',
};

NameFilter.displayName = 'NameFilter';

export default NameFilter;
